import { Theme, defaultTheme } from '@amzn/storm-ui'
import { MobileSetup } from '@amzn/aapn-react-components'

export const overrideTheme = (mobile: MobileSetup): Theme => ({
  ...defaultTheme,
  popover: {
    ...defaultTheme.popover,
    zIndex: 5,
  },
  /** Makes tooltips fade immediately, so there isn't any awkward overlap in mouseovers.
   *  Tooltips are present in the filter menu for "Partner status" and "Official Partner specialists",
   *  as well as mousing over the "Advanced" and "Verified" icons in the partner details cards. */
  tooltip: {
    ...defaultTheme.tooltip,
    mouseLeaveTimeout: 0,
  },
  ...mobile,
})
